export default __webpack_public_path__ + "static/media/cards_flips_3.836d62c9.mp3";